import CryptoJS from 'crypto-js';
import { IAllDebts, InstallmentInfo } from '../context/BatchPaymentContext';
import { IOption } from '../pages/UserVehicles/components/StyledSelect';

export interface IEncryptedPaymentData {
 // Card Related
 type?: string;
 encrypted: string,
 cardName: any,
 cpf: any,
 cep: any,
 
 // Address related
 address: string,
 number: string,
 adjunct: string,
 neighborhood: string,
 uf: string,
 city: string,
 email: string,
 telephone: string,
 ibgeCode?: string,
 
 // Debts Related
 batchCode: number,
 debts: IAllDebts[],
 cupomLocal?: string,
 installment: InstallmentInfo | undefined,

 // Behavior Related
 sub: string | undefined,
 mercadopago?: unknown;
}


const encrypt = (data :any) => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY || '');
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_IV || '');

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString();
};

const decrypt = (data: any) => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY || '');
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_IV || '');

  const decrypted = CryptoJS.AES.decrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};

export { encrypt, decrypt };
